import axiosInstance from "../axiosInstance";

export const actualizarPostventa = async (adminId, data) => {
  return await axiosInstance.put(
    `${process.env.REACT_APP_BASE_URL}/postventa-actualizarPostventa`,
    {
      adminId,
      ...data,
    }
  );
};
